/**
 * Popover horizontal align types.
 * @public
 */
enum PopoverHorizontalAlign {
	/**
	 * Popover is centered.
	 * @public
	 */
	Center = "Center",

	/**
	 * Popover is aligned with the start of the target.
	 * @public
	 */
	Start = "Start",

	/**
	 * Popover is aligned with the end of the target.
	 * @public
	 */
	End = "End",

	/**
	 * Popover is stretched.
	 * @public
	 */
	Stretch = "Stretch",
}

export default PopoverHorizontalAlign;
